
import Api from './Api.service';
export default class NotificarService {
    static NotificarFirebase(token) {
        return Api.get(`test/notificar/token/${token}`);
    }
}